import React from 'react';

const HowWorksPanel = ({ element }) => (
  <div className="section-1__how-works__panel">
    {element.text.map((elem, index) => (
      <div className="section-1__how-works__panel__elem">
        <li>{elem}</li>
      </div>
    ))}
  </div>
);

export default HowWorksPanel;



// WEBPACK FOOTER //
// ./src/components/Static/LandingPage/HowWorksPanel.js